/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { LocationTrackingApiConfiguration as __Configuration } from '../location-tracking-api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { TrackLocationCommand } from '../models/track-location-command';
@Injectable({
  providedIn: 'root',
})
class LocationService extends __BaseService {
  static readonly TrackLocationPath = '/api/tracking/location/track';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param command undefined
   */
  TrackLocationResponse(command?: TrackLocationCommand): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = command;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/tracking/location/track`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param command undefined
   */
  TrackLocation(command?: TrackLocationCommand): __Observable<null> {
    return this.TrackLocationResponse(command).pipe(
      __map(_r => _r.body as null)
    );
  }
}

module LocationService {
}

export { LocationService }
